/**
 * Farm2FeedAPI.js
 * Feed provider from farm2 stream.
 */
import ZLogger from "../../../../../../util/zlogger/zlogger";
import ServiceLocator from "../../../../../../ServiceLocator";

var FeedAPI = (function () {
    var _url_public = "";               /* The URL that will fetch the public feeds */
    var _url_friends = "";               /* The URL that will fetch the friend feeds */
    var _initDone = false;            /* Has this been initialized? */
    var _poc_public = (() => { })        /* The poc function after public feeds have been fetched */
    var _poc_friends = (() => { })        /* The poc function after friend feeds have been fetched */
    var _onErr = (() => { })        /* Error handler function, in case of an error (obviously) */
    var _csrf = "";               /* Registered session csrf token */
    var _zid = 0;                /* Zid of the player who has logged in */
    var _locale = "";               /* The locale in which we have to fetch the feeds */
    var _game_id = 118;              /* The game id for which this is being done */
    var _zFriends = {}                /* Friends data of the user, used to get fetch the friends feeds */
    var _max_feeds_public = 15;
    var _max_feeds_friends = 10;
    var _gameKey = "";

    function Init({
        url_public, url_friends,
        poc_public = (() => { }), poc_friends = (() => { }),
        onErr = (() => { }),
        csrf, zid, zFriends,
        locale = "en_US",
        max_feeds_public = 15, max_feeds_friends = 10,
        gameKey = "",
        gameId = 118
    }) {
        if (gameKey === _gameKey || _initDone) return;
        if (!url_public || !url_friends || !csrf || !zid) {
            ZLogger.fatal("Unable to init feeds, null url or feed instance passed");
            return;
        }
        ZLogger.announce("Initializing friend feeds for GameID: ", process.env.REACT_APP_FARM2_GAME_ID);
        _url_public = url_public
        _url_friends = url_friends
        _poc_public = poc_public;
        _poc_friends = poc_friends
        _onErr = onErr;
        _game_id = gameId;
        _locale = locale;
        _csrf = csrf;
        _zid = zid;
        _max_feeds_public = max_feeds_public;
        _max_feeds_friends = max_feeds_friends;
        _zFriends = zFriends;
        _gameKey = gameKey;
        _initDone = true;
    }

    function Check(lastFriendFeedChecked = 0, other_public = undefined, other_friend = undefined) {
        ZLogger.log("========================= checking feed: ");

        try {
            /* Make request to public fetching endpoint */
            var feedParams = {
                csrf: _csrf,
                locale: _locale, //@TODO: Get this from user locale
                game: _game_id,
                max: _max_feeds_public,
                fmt: "zdc",
                alias: "farmville-two"
            }

            var feedParamsPayload = {
                method: 'POST',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                referrer: 'client',
                body: ServiceLocator.NetworkManager.Utils.GetURLEncoded(feedParams)
            }
            ZLogger.log("Getting public from url: ", _url_public);
            ServiceLocator.NetworkManager.Fetch.Call({
                url: _url_public,
                payload: feedParamsPayload,
                token: "FARM2_FEED_CHECK_PUBLIC"
            })
                .then(resp => { ZLogger.log("PUBLIC_FEED: Got data", resp); return resp.json() })
                .then(resp => { other_public ? other_public(resp) : _poc_public(resp) })
                .catch(err => {
                    ZLogger.fatal("PUBLIC_FEED: Error when refreshing farm2 feeds: ", err);
                    _onErr(err);
                })
        } catch (e) {
            ZLogger.fatal("Exception occurred during public feed check call");
            ZLogger.fatal(e);
        }

        try {
            /* Make request to friend/neighbor fetching endpoint */
            var friendFeedParams = {
                last_feed_ts: "0",
                lmit: _max_feeds_friends,
                locale: _locale,
                "gameIDs[]": _game_id,
                reverse: "true",
                fmt: "zdc",
                first_feed_ts: lastFriendFeedChecked,
                csrf: _csrf,
            }

            // Had to write this just to maintain compatibility.
            // Would be reverse URL encoded. #FML
            var extraParams = {
                "gf": "filter[]",
                "daf": "filter[]",
                "ff": "filter[]",
                "af": "filter[]",
                "phf": "filter[]",
                "impf": "filter[]",
                "trf": "filter[]",
                "agf": "filter[]",
                "aggf": "filter[]"
            }

            // Start parsing the friends lookup and put it in extraparam sources
            // such that all friend feeds including this user's start appearing here.
            extraParams[_zid] = "sources[]";
            ZLogger.log("Adding friends: ", _zFriends);
            for (var each_friend_zid in _zFriends) {
                extraParams[String(each_friend_zid)] = "sources[]"
            }

            var friendFeedPayload = {
                method: 'POST',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                referrer: 'client',
                body: ServiceLocator.NetworkManager.Utils.GetURLEncoded(friendFeedParams) +
                    "&" +
                    ServiceLocator.NetworkManager.Utils.GetURLEncoded(extraParams, true)
            }
            ZLogger.log("Getting friend from url: ", _url_friends);
            ServiceLocator.NetworkManager.Fetch.Call({
                url: _url_friends,
                payload: friendFeedPayload,
                token: "FARM2_FEED_CHECK_FRIEND"
            })
                .then(resp => { ZLogger.log("FRIEND_FEED: Got data", resp); return resp.json() })
                .then(resp => { other_friend ? other_friend(resp) : _poc_friends(resp) })
                .catch(err => {
                    ZLogger.fatal("FRIEND_FEED: Error when refreshing farm2 feeds: ", err);
                    _onErr(err);
                })
        } catch (err) {
            ZLogger.fatal("Exception occurred during friend check of feeds");
            ZLogger.fatal(err);
        }
    }

    function getURLParam(url_string, param) {
        var url = new URL(url_string);
        var p = url.searchParams.get(param);
        return (p === undefined || p === null) ? "abc" : p;
    }

    function TryClaim({ url, authData, onCompleteCallback, onFailureCallback }) {
        onCompleteCallback = (onCompleteCallback) ? onCompleteCallback : (() => { });
        onFailureCallback = (onFailureCallback) ? onFailureCallback : (() => { });
        var feedID = getURLParam(url, "viralId");
        var viralParams = authData || {};
        viralParams["format"] = "json";
        viralParams["viralId"] = feedID;
        viralParams["zySnid"] = "104";
        var viralPayload = {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            referrer: 'client',
            body: ServiceLocator.NetworkManager.Utils.GetURLEncoded(viralParams)
        }
        ServiceLocator.NetworkManager.Fetch.Call({
            url: process.env.REACT_APP_FARM2_VIRAL_ENDPOINT,
            payload: viralPayload,
            token: "FEED-CLAIM-" + feedID
        })
            .then(resp => { return resp.json() })
            .then(resp => { onCompleteCallback(resp) })
            .catch(err => { onFailureCallback(err) });

    }

    return {
        Check: Check,
        Init: Init,
        TryClaim: TryClaim
    }
})();

export default FeedAPI;